import { cloneElement } from 'react';
import useId from '../utilities/useId';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableHead = _ref => {
  let {
    children,
    ...tableHeadProps
  } = _ref;
  const childKeyPrefix = useId('table-head-child--');
  const renderChildren = () => {
    const normalizedChildren = Array.isArray(children) ? children : [children];
    return normalizedChildren.map((child, index) => {
      const key = child?.key ?? `${childKeyPrefix}--${index}`;
      // Extend props before rendering.
      if (child && child.props) {
        return /*#__PURE__*/cloneElement(child, {
          key,
          _isTableHeadChild: true
        });
      }
      return child;
    });
  };
  return /*#__PURE__*/_jsx("thead", {
    role: "rowgroup",
    ...tableHeadProps,
    children: renderChildren()
  });
};
export default TableHead;